import { render } from "./LeadAdvisorForm.vue?vue&type=template&id=7944dce7&scoped=true"
import script from "./LeadAdvisorForm.vue?vue&type=script&lang=js"
export * from "./LeadAdvisorForm.vue?vue&type=script&lang=js"

import "./LeadAdvisorForm.vue?vue&type=style&index=0&id=7944dce7&scoped=true&lang=css"

import exportComponent from "C:\\Users\\lenovo\\Desktop\\canadianlic\\client\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7944dce7"]])

export default __exports__